import { render, staticRenderFns } from "./grapheNature.vue?vue&type=template&id=afe712a2"
import script from "./grapheNature.vue?vue&type=script&lang=js"
export * from "./grapheNature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports